/* eslint-disable no-redeclare */
import type { Selection } from '@tiptap/pm/state';
import type { CellSelection } from '@tiptap/pm/tables';

function isSelectionType(selection: Selection, type: 'cell'): selection is CellSelection;

function isSelectionType(selection: Selection, type: string): boolean {
  if (!selection) {
    return false;
  }
  const serialized = selection.toJSON();
  return serialized.type === type;
}

export function isCellSelection(selection: Selection): selection is CellSelection {
  return isSelectionType(selection, 'cell');
}
